// src/components/gestionEvento/exportTypes/exportMeetI.js

import Papa from 'papaparse';
import {
  formatLastName,
  formatBirthDate,
  getGender,
  getDefaultTeam,
} from '../../../utils/meetUtils';
import { computeAge } from '../../../utils/dateUtils';

/**
 * Exportación en formato Meet Manager (Reporte I).
 * - Un solo registro por atleta (no por prueba).
 * - Sin encabezado.
 * - Delimitado por punto y coma (;).
 *
 * Columnas (I Record) esperadas en Meet Manager:
 *  1.  I
 *  2.  Last Name
 *  3.  First Name
 *  4.  Middle Initial (vacío)
 *  5.  Gender (M/F)
 *  6.  BirthDate (MM/DD/YYYY)
 *  7.  TeamCode
 *  8.  TeamName
 *  9.  Age
 * 10. School Year (vacío)
 * 11. Address (line 1)
 * 12. Province / Address line 2 (opcional)
 * 13. City
 * 14. State
 * 15. Zip
 * 16. Country
 * 17. Citizen Country
 * 18. Phone
 * 19. Office phone
 * 20. Fax
 * 21. Shirt Size
 * 22. Registration #
 * 23. Competitor #
 * 24. Email
 * 25. Disabled class
 */
export function exportMeetI(inscripciones, competitionName) {
  const csvRows = [];

  inscripciones.forEach((insc) => {
    // Col 1: "I"
    const row = ['I'];

    // Col 2: Last Name
    row.push(formatLastName(insc.apellido));

    // Col 3: First Name
    row.push(insc.nombre || '');

    // Col 4: Middle Initial (vacío)
    row.push('');

    // Col 5: Gender (M/F)
    row.push(getGender(insc.rama));

    // Col 6: BirthDate (MM/DD/YYYY)
    row.push(formatBirthDate(insc));

    // Obtenemos TeamCode y TeamName usando getDefaultTeam
    const { teamCode, teamName } = getDefaultTeam(insc.equipo);

    // Col 7: TeamCode
    row.push(teamCode);

    // Col 8: TeamName
    row.push(teamName);

    // Col 9: Age (calculamos con computeAge)
    const ageVal = computeAge(insc.anioNacimiento, insc.mesNacimiento, insc.diaNacimiento);
    row.push(ageVal ? String(ageVal) : '');

    // Col 10: School Year (vacío)
    row.push('');

    // Col 11: Address line 1 (reemplazamos comas si no queremos que rompa el CSV)
    row.push((insc.direccion || '').replace(/,/g, ' '));

    // Col 12: Province o Address line 2 (si no existe, vacío)
    row.push('');

    // Col 13: City
    row.push((insc.ciudad || '').replace(/,/g, ' '));

    // Col 14: State
    row.push((insc.estado || '').replace(/,/g, ' '));

    // Col 15: Zip (lo dejamos vacío o usas algún campo)
    row.push('');

    // Col 16: Country
    row.push((insc.pais || '').replace(/,/g, ' '));

    // Col 17: Citizen Country (ejemplo: 'MEX' o vacío si no se maneja)
    row.push('');

    // Col 18: Phone (insc.telefono)
    row.push(insc.telefono || '');

    // Col 19: Office phone (vacío)
    row.push('');

    // Col 20: Fax (vacío)
    row.push('');

    // Col 21: Shirt Size (vacío)
    row.push('');

    // Col 22: Registration # (podrías usar insc.codigoId o similar)
    row.push(insc.codigoId || '');

    // Col 23: Competitor # (vacío)
    row.push('');

    // Col 24: Email
    row.push(insc.email || '');

    // Col 25: Disabled class (vacío)
    row.push('');

    csvRows.push(row);
  });

  // Convertir a CSV sin encabezado y delimitado por ';'
  let csv = Papa.unparse(csvRows, {
    quotes: false,
    header: false,
    delimiter: ';',
  });

  // Quitar comillas residuales
  csv = csv.replace(/"/g, '');

  // Crear el blob y descargar
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const downloadLink = document.createElement('a');
  downloadLink.href = url;
  downloadLink.setAttribute('download', `${competitionName}_inscritos_MeetManagerI.csv`);
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
  URL.revokeObjectURL(url);
}
